// import React from "react";

// const DoctorDetailsModal = ({ isOpen, onClose, doctorDetails }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white p-6 rounded-md shadow-lg w-[90%] max-w-[800px]">
//         <h2 className="text-2xl font-bold mb-4">Doctor Info</h2>
//         <table className="w-full text-left border border-gray-200">
//           <thead>
//             <tr className="uppercase text-sm leading-normal">
//               <th className="py-2 border-b-[2px] border-b-black w-[40%] text-left text-[13px] px-5">
//                 Fields
//               </th>
//               <th className="py-2 border-b-[2px] border-b-black w-[60%] text-left text-[13px]">
//                 Information
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {doctorDetails ? (
//               <>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50 %] px-5">
//                     Name
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.name}
//                   </td>
//                 </tr>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50%] px-5">
//                     Specialization
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.specialization}
//                   </td>
//                 </tr>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50%] px-5">
//                     Contact
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.phone_no}
//                   </td>
//                 </tr>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50%] px-5">
//                     CNIC
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.cnic}
//                   </td>
//                 </tr>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50%] px-5">
//                     Pay
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.pay}
//                   </td>
//                 </tr>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50%] px-5">
//                     Qualification
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.qualification}
//                   </td>
//                 </tr>
//                 <tr className="text-sm w-full">
//                   <td className="py-2 border-t-[1px] font-bold w-[50%] px-5">
//                     Experience
//                   </td>
//                   <td className="py-2 border-t-[1px] text-[12px] w-[50%]">
//                     {doctorDetails.experience}
//                   </td>
//                 </tr>
//               </>
//             ) : (
//               <tr className="text-sm w-full">
//                 <td
//                   className="py-2 border-t-[1px] font-bold w-full ml-4"
//                   colSpan="2"
//                 >
//                   No details available.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//         <button
//           className="mt-4 px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-400"
//           onClick={onClose}
//         >
//           Close
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DoctorDetailsModal;


import React from "react";

const DoctorDetailsModal = ({ isOpen, onClose, doctorDetails }) => {
  if (!isOpen) return null;

  const fields = [
    { label: "Name", value: doctorDetails?.name },
    { label: "Specialization", value: doctorDetails?.specialization },
    { label: "Contact", value: doctorDetails?.phone_no },
    { label: "CNIC", value: doctorDetails?.cnic },
    { label: "Pay", value: doctorDetails?.pay },
    { label: "Qualification", value: doctorDetails?.qualification },
    { label: "Experience", value: doctorDetails?.experience },
  ];

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 px-4">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-xl w-full max-w-[520px] overflow-hidden">

        {/* Header */}
        <div className="bg-gray-800 px-6 py-5 flex items-center justify-between">
          <div>
            <h2 className="text-white text-[17px] font-[500] tracking-tight">Doctor Info</h2>
            <p className="text-gray-400 text-[12px] mt-0.5">Full profile details</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          {doctorDetails ? (
            <div className="divide-y divide-gray-100">
              {fields.map(({ label, value }) => (
                <div key={label} className="flex items-center justify-between py-3">
                  <span className="text-[12px] font-[500] text-gray-400 uppercase tracking-wide w-[40%]">
                    {label}
                  </span>
                  <span className="text-[13px] text-gray-800 font-[500] w-[60%] text-right">
                    {value || "—"}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-[13px] text-gray-400 text-center py-6">No details available.</p>
          )}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 px-6 py-4 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-800 hover:bg-gray-700 transition-colors text-white text-[13px] font-[500] px-6 py-2.5 rounded-lg"
          >
            Close
          </button>
        </div>

      </div>
    </div>
  );
};

export default DoctorDetailsModal;